import React from "react";
import { Route } from "react-router-dom";
import UploadFile from "./UploadFile";
import FileManagement from "./FileManagement/FileManagement";
import FileInfo from "./FileManagement/FileInfo";
import Processing from "./Processing/Processing";
import NewPricing from "./NewPricing/NewPricing";
import PricingInfo from "./NewPricing/PricingInfo";

export default function Pricing({ match }) {
  return (
    <div className="content">
      <div className="container-fluid">
        <Route path={`${match.url}/upload`} component={UploadFile} />
        <Route
          path={`${match.url}/file-management`}
          component={FileManagement}
        />
        <Route
          path={`${match.url}/file-info/:report_date/:file_name`}
          component={FileInfo}
        />
        <Route path={`${match.url}/new-processing`} component={NewPricing} />
        <Route path={`${match.url}/processing`} component={Processing} />
        <Route path={`${match.url}/pricing-info`} component={PricingInfo} />
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// src/pages/Pricing/index.js